import { render, staticRenderFns } from "./workflow-transition-table.vue?vue&type=template&id=c756ae10"
import script from "./workflow-transition-table.vue?vue&type=script&lang=js"
export * from "./workflow-transition-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports